export default __webpack_public_path__ + "static/media/gel-multi-fruity-1.30748e4a.jpg";